import { useDispatch, useSelector } from 'react-redux'
import Button from '../../components/Button'
import { hasCartItems } from '../../selectors/cart'
import { setRoute } from '../../VNRoutes/ActionCreators'
import { startOrderAction } from '../../VNOrders/ActionCreators'
import { VNORDERS_ACTIONS, VNORDERS_FEATURE_ENABLED } from '../../VNOrders/Enums'
import { getVNOrdersActionsParams } from '../../VNOrders/ActionParams'
import useSpinner from '../../context/hooks/useSpinner'
import { memo, useCallback } from 'react'
import { APPLICATION_STRINGS } from '../../strings'

const PayNowButton = ({ className }) => {
  const dispatch = useDispatch()
  const hasItems = useSelector(hasCartItems)
  const { startSpinner } = useSpinner()

  const handlePayNow = useCallback(() => {
    if (VNORDERS_FEATURE_ENABLED) {
      dispatch(startOrderAction(VNORDERS_ACTIONS.START_ORDER, getVNOrdersActionsParams('/tender-selection')))
      return
    }

    startSpinner()
    dispatch(setRoute('/tender-select-loader'))
  }, [dispatch, startSpinner])

  return (
    <Button useMui className={className} disabled={!hasItems} onClick={handlePayNow}>
      {APPLICATION_STRINGS.PAY_NOW}
    </Button>
  )
}

export default memo(PayNowButton)
